import React, { useEffect, useState } from "react"; 
import { useSelector } from "react-redux";
import $ from "jquery";

import useApi from "../../../CustomHooks/useApi";
import useRDService from "../../../CustomHooks/useRDService";
import DeviceStatus from "../NewAeps/DeviceStatus";

const FingpayCMS = () => {
  const { lat, lng } = useSelector((s) => s.location);

  const username = useSelector(
    (state) => state.auth.employeeDetails?.username
  );

  const [otp, setOtp] = useState("");
  const [amount, setAmount] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [showMobileForm, setShowMobileForm] = useState(true);

  const [loading, setLoading] = useState(false);
  const [merchantLoading, setMerchantLoading] = useState(false);

  const [merchantData, setMerchantData] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const [showOnlyBio, setShowOnlyBio] = useState(false);

  // ================= APIs =================

  const { callApi: createMerchantApi } = useApi(
    "/v1/fingpay/merchant/create",
    "POST"
  );

  const { callApi: sendOtpApi } = useApi(
    "/v1/fingpay/ekyc/send-otp",
    "POST"
  );

  const { callApi: validateOtpApi } = useApi(
    "/v1/fingpay/ekyc/validate-otp",
    "POST"
  );

  const { callApi: resendOtpApi } = useApi(
    "/v1/fingpay/ekyc/resend-otp",
    "POST"
  );

  const { callApi: biometricApi } = useApi(
    "/v1/fingpay/ekyc/biometric",
    "POST"
  );

  const { callApi: startCmsApi } = useApi(
    "/new/cms/start",
    "POST"
  );

  // ================= RD SERVICE =================

  const {
    device,
    captureFingerprint,
    loading: rdLoading,
  } = useRDService();

  // ================= CREATE MERCHANT (manual trigger) =================

  const handleCreateMerchant = async () => {
    if (!mobileNumber || mobileNumber.trim().length < 10) {
      setErrMsg("Please enter a valid 10-digit mobile number");
      return;
    }
    setErrMsg("");
    await checkMerchantStatus(mobileNumber.trim());
  };

  const checkMerchantStatus = async (mob) => {
    const mobToUse = mob || mobileNumber;
    try {
      setMerchantLoading(true);
      setShowOnlyBio(false);

      const res = await createMerchantApi(
        null,
        `?username=${username}&mobileNumber=${mobToUse}`
      );

      console.log("Merchant Response =>", res);

      setMerchantData(res);
      setShowMobileForm(false);
    } catch (error) {
      console.log(error);
      setErrMsg(error?.message || "Merchant check failed");
    } finally {
      setMerchantLoading(false);
    }
  };

  // ================= PID XML PARSER =================

  const parsePidXml = (xml) => {
    const $xml = $(xml);

    const get = (selector, attr) =>
      $xml.find(selector).attr(attr) || "0";

    const infoValue = (name) =>
      $xml.find(`Info[name='${name}']`).attr("value") ||
      $xml.find(`Param[name='${name}']`).attr("value") ||
      "0";

    return {
      dc: get("DeviceInfo", "dc"),
      ci: get("Skey", "ci"),
      hmac: $xml.find("Hmac").text() || "0",
      dpID: get("DeviceInfo", "dpId"),
      mc: get("DeviceInfo", "mc"),
      PidDatatype: get("Data", "type"),
      sessionKey: $xml.find("Skey").text() || "0",
      mi: get("DeviceInfo", "mi"),
      rdsID: get("DeviceInfo", "rdsId"),
      errCode: get("Resp", "errCode"),
      errInfo: get("Resp", "errInfo"),
      fCount: get("Resp", "fCount"),
      fType: get("Resp", "fType"),
      iCount: get("Resp", "iCount"),
      iType: get("Resp", "iType"),
      pCount: get("Resp", "pCount"),
      pType: "0",
      srno: infoValue("srno"),
      sysid: infoValue("sysid"),
      ts: infoValue("ts"),
      Piddata: $xml.find("Data").text() || "0",
      qScore: get("Resp", "qScore"),
      nmPoints: get("Resp", "nmPoints"),
      rdsVer: get("DeviceInfo", "rdsVer"),
    };
  };

  // ================= OTP =================

  const handleSendOtp = async () => {
    try {
      setLoading(true);

      const res = await sendOtpApi(
        null,
        `?username=${username}&mobileNumber=${mobileNumber}`
      );

      if (res.statusCode === 10000) {
        setSuccessMsg("OTP Sent Successfully");
      } else {
        setErrMsg("OTP Sent Failed")
      }

      setTimeout(() => {
        setSuccessMsg("");
        setErrMsg("");
      }, 3000);

      // input clear
      setOtp("");

    } catch (error) {
      setErrMsg(error?.message || "OTP send failed");
    } finally {
      setLoading(false);
    }
  };

  const handleValidateOtp = async () => {
    try {
      if (!otp) {
        return setErrMsg("Please enter OTP");
      }

      setLoading(true);

      const res = await validateOtpApi(
        null,
        `?username=${username}&otp=${otp}`
      );

      if (res.statusCode === 10000) {
        setSuccessMsg("OTP Verified Successfully");
      } else if (res.statusCode === 999) {
        setSuccessMsg("OTP Verified Successfully. Please complete Biometric.");
        setShowOnlyBio(true);
      } else {
        setErrMsg("OTP Verified Failed")
      }

      // OTP clear
      setOtp("");

      // auto hide message
      setTimeout(() => {
        setSuccessMsg("");
        setErrMsg("");
      }, 3000);

    } catch (error) {
      setErrMsg(error?.message || "OTP validation failed");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);

      const res = await resendOtpApi(
        null,
        `?username=${username}&mobileNumber=${mobileNumber}`
      );

      if (res.statusCode === 10000) {
        setSuccessMsg("OTP Sent Successfully");
      } else {
        setErrMsg("OTP Sent Failed")
      }

      setOtp("");

      // auto hide message
      setTimeout(() => {
        setSuccessMsg("");
      }, 3000);
    } catch (error) {
      setErrMsg(error?.message || "OTP resend failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= BIOMETRIC =================

  const handleBiometricEkyc = async () => {
    try {
      setLoading(true);

      const wadhvalue =
        "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=";

      // Capture Fingerprint
      const pidXml = await captureFingerprint(wadhvalue);

      if (!pidXml) {
        return setErrMsg("Fingerprint capture failed");
      }

      // Parse PID XML
      const parsedData = parsePidXml(pidXml);

      // Biometric API Call
      const res = await biometricApi(
        parsedData,
        `?username=${username}`
      );

      console.log("Biometric Response =>", res);

      // =========================
      // BANK EKYC PENDING CONDITION
      // =========================
      if (
        res?.statusCode === 10000 &&
        res?.message?.includes(
          "Please complete Bank eKYC"
        )
      ) {
        setSuccessMsg(
          "Bank eKYC pending. OTP sent again. Please verify OTP and capture fingerprint again."
        );
        setShowOnlyBio(false);

        // Auto hide message
        setTimeout(() => {
          setSuccessMsg("");
        }, 5000);

        return;
      }

      if (
        res?.statusCode === 10000 &&
        res?.message?.includes(
          "Bank eKyc successfully completed"
        )
      ) {
        // Success Message
        setSuccessMsg(
          "Bank eKyc successfully completed"
        );

        checkMerchantStatus();

        // Auto hide message
        setTimeout(() => {
          setSuccessMsg("");
        }, 5000);
      }

      // =========================
      // SUCCESS CASE
      // =========================
      setErrMsg(
        res?.message
      );

      // Auto hide message
      setTimeout(() => {
        setSuccessMsg("");
        setErrMsg("");
      }, 3000);

    } catch (error) {
      console.log(error);

      setErrMsg(
        error?.message || "Biometric eKYC failed"
      );

    } finally {
      setLoading(false);
    }
  };

  // ================= START CMS =================

  const handleStartCms = async () => {
    try {
      if (!amount) {
        return setErrMsg("Please enter amount");
      }

      setLoading(true);

      const payload = {
        lat: lat,
        longitude: lng,
        merchantId: username,
        amount: amount,
      };

      const res = await startCmsApi(payload);

      console.log("CMS Response =>", res);

      // redirect in new tab
      if (res?.redirectionUrl) {
        window.open(
          res?.redirectionUrl,
          "_blank",
          "noopener,noreferrer"
        );
      } else {
        setErrMsg("Redirection URL not found");
      }

    } catch (error) {
      console.log(error);
      setErrMsg(error?.message || "CMS start failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= CONDITIONS =================

  const isMerchantActive =(
    merchantData?.status === true &&
    merchantData?.data?.merchantStatus === true &&
    merchantData?.statusCode === 10000 || merchantData?.statusCode === 200 ) 

  // New logic for checking remarks, ensuring 888 bypasses blocking remark logic
  const remarks = merchantData?.data?.remarks || "";
  const isBlockingRemark = 
    merchantData?.statusCode !== 888 && 
    remarks && 
    !remarks.toLowerCase().includes("complete biokyc");

  // ================= UI =================

  return (
    <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-lg border p-6">

      <DeviceStatus
        device={device}
      />

      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">
          CMS
        </h2>

        <p className="text-sm text-gray-500 mt-1">
          Merchant onboarding & CMS service
        </p>
      </div>

      {/* Mobile Number Input Form */}
      {showMobileForm && (
        <div className="mb-6">
          <p className="text-sm text-gray-600 mb-3 font-medium">
            Enter your mobile number to continue
          </p>
          <div className="flex gap-3">
            <input
              type="tel"
              maxLength={10}
              placeholder="Enter 10-digit Mobile Number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
              onKeyDown={(e) => e.key === "Enter" && handleCreateMerchant()}
              className="flex-1 border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-indigo-500"
            />
            <button
              onClick={handleCreateMerchant}
              disabled={merchantLoading}
              className="bg-[#12345A] hover:bg-[#12345A]/90 text-white px-6 rounded-xl font-medium disabled:opacity-50 transition-all"
            >
              {merchantLoading ? "Please Wait..." : "Continue"}
            </button>
          </div>
          {errMsg && (
            <div className="mt-3 bg-red-100 text-red-700 px-4 py-2 rounded-xl text-sm font-medium">
              {errMsg}
            </div>
          )}
        </div>
      )}

      {/* Loading */}
      {!showMobileForm && merchantLoading ? (
        <div className="text-center py-10">
          <p className="text-gray-500 font-medium">
            Checking merchant status...
          </p>
        </div>
      ) : !showMobileForm && (
        <>
          {/* Merchant Active */}
          {isMerchantActive ? (
            <div className="space-y-4">

              <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                <p className="text-green-700 font-semibold">
                  Merchant Activated Successfully
                </p>

                <p className="text-sm text-gray-600 mt-1">
                  Merchant ID :
                  {" "}
                  {merchantData?.data?.merchantLoginId}
                </p>
              </div>

              <input
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-black"
              />

              <button
                onClick={handleStartCms}
                disabled={loading}
                className="w-full bg-black hover:bg-gray-900 text-white py-3 rounded-xl font-semibold transition"
              >
                {loading ? "Please Wait..." : "Start CMS"}
              </button>
            </div>
          ) : isBlockingRemark ? (
            /* Blocking Remark Case: Show error message instead of OTP page */
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-5">
              <p className="text-red-700 font-semibold">
                Merchant Validation Error
              </p>
              <p className="text-sm text-red-600 mt-1 whitespace-pre-line">
                {remarks}
              </p>
            </div>
          ) : (
            <>
              {/* Pending KYC (Shows if NO blocking remarks, remark is "complete biokyc", or statusCode is 888) */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-5">
                <p className="text-yellow-700 font-semibold">
                  Merchant KYC Pending
                </p>

                <p className="text-sm text-gray-600 mt-1">
                  {showOnlyBio ? "Complete Biometric verification" : "Complete OTP & Biometric verification"}
                </p>
              </div>

              {/* OTP Input - Hidden if showOnlyBio is true */}
              {!showOnlyBio && (
                <div className="flex gap-3 mb-4">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="flex-1 border border-gray-300 rounded-xl px-4 py-3 outline-none"
                  />

                  <button
                    onClick={handleValidateOtp}
                    disabled={loading}
                    className="bg-indigo-600 text-white px-5 rounded-xl"
                  >
                    Verify
                  </button>
                </div>
              )}

              {successMsg && (
                <div className="mb-3 bg-green-100 text-green-700 px-4 py-2 rounded-xl text-sm font-medium">
                  {successMsg}
                </div>
              )}

              {errMsg && (
                <div className="mb-3 bg-red-100 text-red-700 px-4 py-2 rounded-xl text-sm font-medium">
                  {errMsg}
                </div>
              )}

              {/* Action Buttons */}
              <div className="grid grid-cols-2 gap-4">
                
                {/* Hide OTP action buttons if showOnlyBio is true */}
                {!showOnlyBio && (
                  <>
                    <button
                      onClick={handleSendOtp}
                      disabled={loading}
                      className="bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-medium"
                    >
                      Send OTP
                    </button>

                    <button
                      onClick={handleResendOtp}
                      disabled={loading}
                      className="bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-medium"
                    >
                      Resend OTP
                    </button>
                  </>
                )}

                <button
                  onClick={handleBiometricEkyc}
                  disabled={loading || rdLoading}
                  className="col-span-2 bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-xl font-medium"
                >
                  {rdLoading
                    ? "Capturing Fingerprint..."
                    : "Complete Biometric eKYC"}
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default FingpayCMS;